import React, {ReactNode, useEffect} from "react";
import GoogleAnalyticsContext from "./googleAnalytics.context";
import {useOrganizationConfig} from "../OrganizationConfig/useOrganizationConfig";

interface GoogleAnalyticsProviderProps {
  children: ReactNode;
}

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GoogleAnalyticsProvider: React.FC<GoogleAnalyticsProviderProps> = ({
  children,
}) => {
  const {moduleConfig} = useOrganizationConfig();
  const googleTag = moduleConfig?.customValues?.googleTag;

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.info("Google Tag is only initialized in production");
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${googleTag}`;
    script.async = true;
    document.body.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", googleTag, {debug: true});

    window.gtag("config", googleTag, {
      page_path: window.location.pathname,
    });
  }, [googleTag]);

  const sendEvent = (
    category: string,
    action: string,
    label: string,
    value: number,
  ) => {
    if (window.gtag) {
      window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  };

  return (
    <GoogleAnalyticsContext.Provider value={{sendEvent}}>
      {children}
    </GoogleAnalyticsContext.Provider>
  );
};

export default GoogleAnalyticsProvider;
